export default __webpack_public_path__ + "assets/img_no_object-2a3bdf8b.jpg";